import { useCallback, useMemo } from "react";

import type { IEmployeeLocationFilterDto } from "app/pages/sales-intelligence/domain/contacts/types/filter-values";
import { assembleEmployeeLocationFilterDTO } from "app/pages/sales-intelligence/domain/contacts/utils/filter-dto-adapters";
import { EmployeeLocationSelector } from "app/pages/sales-intelligence/modules/contacts-search-filters/components/EmployeeLocationSelector/EmployeeLocationSelector";
import { binaryInclusionOptions, inclusionOptionMap } from "app/pages/sales-intelligence/types/commonMaps";
import type { ICountryObject } from "app/services/CountryService";
import type { IRegionObject } from "app/services/RegionService";

type PlaybookEmployeeLocationSelectorProps = {
    value?: IEmployeeLocationFilterDto;
    onChange: (value?: IEmployeeLocationFilterDto) => void;
    countries: readonly ICountryObject[];
    regions: readonly IRegionObject[];
};

export const PlaybookEmployeeLocationSelector = ({
    value,
    onChange,
    countries,
    regions,
}: PlaybookEmployeeLocationSelectorProps) => {
    const options = useMemo(
        () => ({
            countries,
            regions,
            inclusions: binaryInclusionOptions,
        }),
        [countries, regions],
    );

    const handleChange = useCallback(
        (nextValue: IEmployeeLocationFilterDto) => {
            onChange(
                assembleEmployeeLocationFilterDTO(
                    nextValue.inclusion ?? inclusionOptionMap.includeOnly,
                    nextValue.codes ?? [],
                    nextValue.regions ?? [],
                ),
            );
        },
        [onChange],
    );

    return (
        <EmployeeLocationSelector
            value={value}
            onChange={handleChange}
            options={options}
            dataAutomation="playbook-wizard-employee-location"
        />
    );
};
